import { Autocomplete, Box, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import type { AuthUser } from "../../../api/types";
import type { Branch, Company, Contact, Deal, Grower, Job } from "../../../models";
import type { FeatureStats } from "../ImportTable/ImportTable/ImportTable.types";

export interface ImportFormProps {
	currentUser?: AuthUser;
	selectedDeals: Deal[];
	selectedBranches: Branch[];
	deals: Deal[];
	user?: Contact;
	selectedCompany: Company | null;
	salespersons?: Contact[];
	growers?: Grower[];
	branches?: Branch[];
	lastCropOptions: string[];
	nextCropOptions: string[];
	/** Called when jobs are extracted/loaded, passing jobs and stats to parent (modal mode) */
	onJobsExtracted?: (jobs: Job[], featureStats?: FeatureStats) => void;
	/** Called to close the modal */
	onClose?: () => void;
	/** True when form is rendered inside a modal */
	isInModal?: boolean;
}

export function loadItemsButton(disabled: boolean, onClick: () => Promise<void>, label: string): React.ReactNode {
	return (
		<Grid size={12}>
			<Button
				fullWidth
				disabled={disabled}
				style={{ marginTop: 20 }}
				variant="contained"
				color="primary"
				onClick={onClick}
			>
				{label}
			</Button>
		</Grid>
	);
}

export function itemSelector<T>(
	disabled: boolean,
	options: T[],
	selectedOptions: T[],
	handleChange: (event: any, value: T[]) => void,
	setSelectedOptions: React.Dispatch<React.SetStateAction<T[]>>,
	getOptionKey: (option: T) => string,
	getOptionLabel: (option: T) => string,
	label: string,
): React.ReactNode {
	return (
		<Grid size={12}>
			<Box
				sx={{
					display: "flex",
					flexDirection: { xs: "column", sm: "row" },
					alignItems: { xs: "stretch", sm: "center" },
					gap: 1,
				}}
			>
				<Autocomplete
					fullWidth
					className="proacrica-select-dropdown"
					multiple
					disabled={disabled}
					options={options}
					value={selectedOptions}
					getOptionKey={getOptionKey}
					getOptionLabel={getOptionLabel}
					onChange={handleChange}
					renderInput={(params) => <TextField {...params} label={label} variant="outlined" />}
				/>
				<Button
					disabled={disabled}
					variant="contained"
					className="proacrica-select-selectall"
					onClick={() => setSelectedOptions(options)}
				>
					Select All
				</Button>
			</Box>
		</Grid>
	);
}

interface FileNames {
	/** Boundary */
	bndName: string;
	/** Points */
	ptsName: string;
	/** Zones */
	znsName: string;
	/** Centroids */
	cdsName: string;
	/** Cores */
	crsName: string;
}

export function generateFileNames(growerName: string, farmName: string, fieldName: string): FileNames {
	const prefix = [fieldName, farmName, growerName].filter((val) => val && val !== "").join("_");
	const randomId = Math.random().toString(36).substring(2, 6);

	return {
		bndName: `${prefix}_${randomId}_boundary`,
		ptsName: `${prefix}_${randomId}_points`,
		znsName: `${prefix}_${randomId}_zones`,
		cdsName: `${prefix}_${randomId}_centroids`,
		crsName: `${prefix}_${randomId}_cores`,
	};
}
